<template>
    <v-layout fill-height row justify-center :class="flexClass">
        <v-progress-linear :indeterminate="true" v-if="progressBarVisible" class="ma-0 pa-0 progress-top"></v-progress-linear>
        <v-flex sm12 lg11 xl8 p-0>
            <v-card class="fill-height">
                <!-- <v-breadcrumbs :items="breadCrumbs" class="dense">
                    <template v-slot:divider>
                        <v-icon>forward</v-icon>
                    </template>
                </v-breadcrumbs> -->
                <!--
                <v-card-title>
                    <h2>{{ $t("myAccount") }}</h2>
                </v-card-title>
                -->

                <v-toolbar card prominent dense>
                    <v-tooltip
                        bottom
                        :disabled="true"
                    >
                        <template v-slot:activator="{ on }">
                            <v-btn
                                flat
                                v-on="on"
                                @click="getSubscriptionInfo"
                            >
                                <v-icon>mdi-reload</v-icon> {{ $t("reload") }}
                            </v-btn>
                        </template>
                        <span>{{ $t("reload") }}</span>
                    </v-tooltip>
                </v-toolbar>

                <v-card-text class="v-scrollable">
                    <v-container grid-list-md pb-0>
                        <v-layout wrap>
                            <v-flex xs12>
                                {{ $t("subscription") }}: {{ subscription.title || $t("no")}}
                            </v-flex>
                            <v-flex xs12 mb-4>
                                {{ $t("validThrough")}} {{ subscription.expired }}
                            </v-flex>

                            <v-flex xs5>
                                {{ $t("maxUsers") }}
                            </v-flex>
                            <v-flex xs5>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                            color="info"
                                            height="10"
                                            v-model="percents.users"
                                            v-on="on"
                                            class="my-2"
                                        ></v-progress-linear>
                                    </template>
                                    <span>{{ percents.users }}%</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs2>
                                {{ used.users}} / {{ limits.maxUsers }}
                            </v-flex>

                            <v-flex xs5>
                                {{ $t("maxPatterns") }}
                            </v-flex>
                            <v-flex xs5>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                            color="info"
                                            height="10"
                                            v-model="percents.patterns"
                                            v-on="on"
                                            class="my-2"
                                        ></v-progress-linear>
                                    </template>
                                    <span>{{ percents.patterns }}%</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs2>
                                {{ used.patterns}} / {{ limits.maxPatterns }}
                            </v-flex>

                            <v-flex xs5>
                                {{ $t("maxModels") }}
                            </v-flex>
                            <v-flex xs5>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                            color="info"
                                            height="10"
                                            v-model="percents.models"
                                            v-on="on"
                                            class="my-2"
                                        ></v-progress-linear>
                                    </template>
                                    <span>{{ percents.models }}%</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs2>
                                {{ used.models}} / {{ limits.maxModels }}
                            </v-flex>

                            <v-flex xs5>
                                {{ $t("maxLines") }}
                            </v-flex>
                            <v-flex xs5>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-progress-linear
                                            color="info"
                                            height="10"
                                            v-model="percents.lines"
                                            v-on="on"
                                            class="my-2"
                                        ></v-progress-linear>
                                    </template>
                                    <span>{{ percents.lines }}%</span>
                                </v-tooltip>
                            </v-flex>
                            <v-flex xs2>
                                {{ used.lines}} / {{ limits.maxLines }}
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-layout align-center justify-center>
                        <v-btn
                            class="mt-3 mb-3"
                            color="success"
                            @click="$refs.BuySubscriptionDialog.dialog = true"
                        >{{ $t("buySubscription") }}</v-btn>
                    </v-layout>

                    <tariffs-table class="pa-0 ma-0"/>
                </v-card-text>
            </v-card>

            <message-box            ref="MessageBox"/>
            <buy-subscription-dialog ref="BuySubscriptionDialog"/>

            <v-alert
                :value="alert !== ''"
                :type="alertType"
                transition="scale-transition"
                class="bottom-alert"
            >
                {{ alert }}
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
    import MessageBox               from "@/components/dialogs/MessageBox";
    import BuySubscriptionDialog    from "@/components/dialogs/BuySubscriptionDialog";
    import TariffsTable             from "@/components/account/TariffsTable";

    export default {
        name: "SubscriptionForm",

        inject: ["theme"],

        components: {
            MessageBox,
            TariffsTable,
            BuySubscriptionDialog
        },

        data () {
            return {
                alert:     "",
                alertType: "success",
                breadCrumbs: [
                    { text: "Моя подписка", disabled: false },
                ],
                limits: {
                    maxUsers:    1,
                    maxPatterns: 1,
                    maxModels:   1,
                    maxLines:    1
                },

                used: {
                    users:    0,
                    patterns: 0,
                    models:   0,
                    lines:    0
                },

                percents: {
                    users:    0,
                    patterns: 0,
                    models:   0,
                    lines:    0
                },

                subscription: {
                    id:      null,
                    title:   null,
                    expired: null,
                },

                newSubscription: "standard3",

                loading: {
                    subscriptionInfo: false,
                    requestRenewal:   false
                },

            }
        },

        watch: {
            alert: function (val) {
                let component = this;
                if (val !== "") {
                    setTimeout(() => {
                        component.alert = "";
                    }, 3000);
                }
            },

            limis: {
                handler: function () {
                    this.calcPercents();
                },
                deep: true
            },

            used: {
                handler: function () {
                    this.calcPercents();
                },
                deep: true
            }
        },

        computed: {
            flexClass () {
                return {
                    //lgUp: this.$vuetify.breakpoint.lgAndUp,
                    "md-up": this.$vuetify.breakpoint.mdAndUp
                }
            },

            progressBarVisible () {
                return this.loading.subscriptionInfo || this.loading.requestRenewal;
            }
        },

        mounted () {

            this.limits = this.$store.getters.subscription.limits
                ? this.$store.getters.subscription.limits
                : {
                    maxUsers:    1,
                    maxPatterns: 1,
                    maxModels:   1,
                    maxLines:    1
                };

            this.subscription.title   = this.$store.getters.subscription.title;
            this.subscription.expired = this.$store.getters.subscription.expired;
            this.subscription.id      = this.$store.getters.subscription.id;
            this.applyLocale();
            this.getSubscriptionInfo();

            this.$root.$on("localeChanged", () => { this.applyLocale(); });

            this.newSubscription = this.subscription.title == this.$t("subscriptionPlans.professional")
                ? "pro12"
                : "standard12";
        },

        methods: {
            /**
             * Применение локали
             */
            applyLocale () {
                this.breadCrumbs = [
                    { text: this.$t("mySubscription"), disabled: false }
                ];
            },

            /**
             * Вычисление процентов
             */
            calcPercents () {
                this.percents.users    = Math.round(this.used.users / this.limits.maxUsers * 100);
                this.percents.patterns = Math.round(this.used.patterns / this.limits.maxPatterns * 100);
                this.percents.models   = Math.round(this.used.models / this.limits.maxModels * 100);
                this.percents.lines    = Math.round(this.used.lines / this.limits.maxLines * 100);
            },

            /**
             * Получение информации о подписке
             */
            getSubscriptionInfo () {
                this.loading.subscriptionInfo = true;

                this.axios.get(`${this.$config.apiURL}subscriptions/my/`, { withCredentials: true })
                .then(response => {
                    if (response.data.subscription == undefined) { return; }

                    let subscriptionInfo = response.data.status == "success"
                        ? response.data.subscription
                        : {};

                    this.used = {
                        users:    subscriptionInfo.Users,
                        patterns: subscriptionInfo.Patterns,
                        models:   subscriptionInfo.Models,
                        lines:    subscriptionInfo.Lines,
                        isActive: subscriptionInfo.Visible
                    };

                    this.loading.subscriptionInfo = false;
                }).catch(error => {
                    this.loading.subscriptionInfo = false;

                    if (error.response && error.response.status == 401) {
                        this.showMessageBox(this.$t("error"), this.$t("sessionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { window.location.reload(); }
                        );
                    } else if (error.response && error.response.status == 402) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo") + ". " + this.$t("subscriptionExpired"));

                        // Удаление наблюдателя если установлен
                        if (this.dialogWatcher !== null) { this.dialogWatcher(); }

                        // Отслеживание нажатия кнопки ok в диалоге
                        this.dialogWatcher = this.$watch(
                            "$refs.MessageBox.dialog",
                            () => { this.$emit("doLogout", true); }
                        );
                    } else if (error.response && error.response.status == 403 && typeof error.response.data !== "object" && error.response.data.trim() == "Access denied. Session id mismatch") {
                        this.showMessageBox(this.$t("error"), `${this.$t("accessDenied")}. ${this.$t("sessionIdMismatch")}.`);
                    } else if (error.response && error.response.status == 403) {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo") + ". " + this.$t("accessDenied"));
                    } else {
                        this.showMessageBox(this.$t("error"), this.$t("cantLoadUserInfo"));
                    }
                });
            },

            /**
             * Отображение сообщения
             *
             * @param {string} title       Заголовок
             * @param {string} messageText Текст сообщения
             */
            showMessageBox (title, messageText) {
                this.$refs.MessageBox.title       = title;
                this.$refs.MessageBox.messageText = messageText;
                this.$refs.MessageBox.dialog      = true;
            }
        }
    }
</script>

<style lang="sass" scoped>
    .v-scrollable
        overflow-y: auto
        max-height: calc(100dvh - 98px)

    .table
        margin-top: 16px
        margin-bottom: 8px
        max-height: 100% !important
        min-width: 1000px
        text-align: center
        border-spacing: 0
        border: 1px solid #c4c1c1
        border-right: 0
        border-top: 0
        td
            padding: 2px
            height: 25px
            border: 1px solid #c4c1c1
            border-bottom: 0
            border-left: 0
</style>
